import { lazy } from 'react'

const TransactionCreate = lazy(() => import(
  /* webpackChunkName: "transaction-create" */ './Create'
))

const TransactionDetails = lazy(() => import(
  /* webpackChunkName: "transaction-details" */ './Details/Details'
))

const TransactionsSearch = lazy(() => import(
  /* webpackChunkName: "transactions" */ './Search/Search'
))

export {
  TransactionCreate,
  TransactionDetails,
  TransactionsSearch,
}
